/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse,
  (params: vp.SubmitTicketCommentRequst) => void,
  (params: vp.SubmitTicketCommentRequst) => Promise<vp.ApiResponse>,
  () => void,
];

function usePostSubmitTicketComment({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.SubmitTicketCommentRequst>();
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.SubmitTicketCommentRequst) => {
      setDataFetchingInfo(true, 'Your reply is being submitted', 'fullScreen');

      const res = await api.postSubmitTicketCommentClient(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.SubmitTicketCommentRequst) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    (requestParams: vp.SubmitTicketCommentRequst) => api.postSubmitTicketCommentClient(requestParams, source),
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostSubmitTicketComment);
